export default "__VITE_ASSET__J0mhFQMv__"